import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "styled-components";
import { _ } from "../utils/i18n";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding: 20px;
  box-shadow: none;
  border-radius: 4px;
  color: #1b2636;
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  background-color: #fff;
  @media (min-width: 800px) {
    width: 480px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
  }
  @media (max-width: 1025px) {
    width: 48%;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
  }
  @media (min-width: 1025px) {
    width: 580px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
    margin: 20px 0;
  }
`;
const Title = styled.h2`
  font-size: 1.5rem;
  @media (max-width: 940px) {
    font-size: 1.2rem;
    margin-bottom: 10px;
  }
`;
const LinkLabel = styled((props) => <Link {...props} />)`
  color: #f15e4e; /* theme.palette.text.secondary */
  text-decoration: none;
  &:visited {
    color: #f15e4e;
  }
  &:hover {
    text-decoration: underline;
  }
`;

const TextCard = ({ title, excerpt, linkUrl }) => {
  return (
    <Container>
      <Title>{title}</Title>
      <p>{excerpt}</p>
      {linkUrl !== "" &&
        linkUrl !== "null" &&
        linkUrl !== null &&
        linkUrl !== undefined && (
          <LinkLabel to={linkUrl}>{_("Les mer")}</LinkLabel>
        )}
    </Container>
  );
};

TextCard.propTypes = {
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  linkUrl: PropTypes.string,
};

TextCard.defaultProps = {
  linkUrl: "",
};

export default TextCard;
